import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAgent: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAgent"><Path d="M12 2.5C13.933 2.5 15.5 4.067 15.5 6C15.5 7.58536 14.4455 8.92311 13 9.35352V11H19V14.6455C20.4457 15.0758 21.5 16.4145 21.5 18C21.5 19.933 19.933 21.5 18 21.5C16.067 21.5 14.5 19.933 14.5 18C14.5 16.4145 15.5543 15.0758 17 14.6455V13H7V14.6455C8.44566 15.0758 9.5 16.4145 9.5 18C9.5 19.933 7.933 21.5 6 21.5C4.067 21.5 2.5 19.933 2.5 18C2.5 16.4145 3.55434 15.0758 5 14.6455V11H11V9.35352C9.55447 8.92311 8.5 7.58536 8.5 6C8.5 4.067 10.067 2.5 12 2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAgent;
